import BASE_API from "../../shared/utility/base-api"

export const REQUEST_ENDPOINT = {
  detail: `${import.meta.env.VITE_APP_API}/requests/get-request`,
  list: `${import.meta.env.VITE_APP_API}/requests/get-requests`,
  archive: `${import.meta.env.VITE_APP_API}/requests/archive-request`,
  delete: `${import.meta.env.VITE_APP_API}/requests/delete-request`,
  toggleStatus: `${
    import.meta.env.VITE_APP_API
  }/requests/activate-or-block-request`,
  restore: `${import.meta.env.VITE_APP_API}/requests/restore-request`,
  archivedRequests: `${
    import.meta.env.VITE_APP_API
  }/requests/get-archived-requests`,
  archivedRequest: `${
    import.meta.env.VITE_APP_API
  }/requests/get-archived-request`,
  create: `${import.meta.env.VITE_APP_API}/requests/create-request`,
  update: `${import.meta.env.VITE_APP_API}/requests/update-request`,
  updateProfile: `${
    import.meta.env.VITE_APP_API
  }/requests/update-request-profile-image/`,

  export: `${import.meta.env.VITE_APP_API}/requests/export-requests`,

  assignRequest: `${BASE_API}/requests/assign-request`,
  removeFile: `${BASE_API}/requests/remove-image`,
  changeRequestStatus: `${BASE_API}/requests/change-request-status`,
}
